import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useGoogleAdsense } from '../../hooks'

const GoogleAdsWrapper = () => {
  const [searchParams] = useSearchParams()
  const isAdsTest = searchParams.has('adsTest')
  const { useAdsense } = useGoogleAdsense()
  const shouldBeAds = useAdsense

  useEffect(() => {
    const script = document.querySelector('script[src*="adsbygoogle.js"]')
    console.log('Google Adsense [script]', script)

    if (!shouldBeAds && script) {
      script.remove()
      console.log('Google Adsense [script] removed')
      // return
    }

    // if (shouldBeAds && !script) {
    //   try {
    //     const script = document.createElement('script')
    //     script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT}`
    //     script.async = true
    //     script.crossOrigin = 'anonymous'
    //     // PENG-2099 - Remove if Success
    //     if (!isAdsTest) {
    //       console.log('Legacy Script Loading...')
    //       script.onload = () => {
    //         // Trigger googleadsense to reprocess the ads in the page.
    //         (window.adsbygoogle = window.adsbygoogle || []).push({})
    //       }
    //     }
    //     document.head.appendChild(script)

    //     // PENG-2099 - Remove if statement on Success
    //     if (isAdsTest) {
    //       console.log('New Script Loading...')
    //       /*
    //           * GoogleAdsWrapper component with MutationObserver added
    //           * Then now, it waits for Google to automatically inject <ins class="adsbygoogle adsbygoogle-noablate"> into the DOM before running adsbygoogle.push({}).
    //         */
    //       // Start observing for ad slots after script loads
    //       script.onload = () => {
    //         console.log('Adsense script loaded, starting MutationObserver...')

    //         const observer = new MutationObserver(() => {
    //           const unprocessedIns = document.querySelector('ins.adsbygoogle:not([data-adsbygoogle-status])')

    //           if (unprocessedIns && window.adsbygoogle) {
    //             try {
    //               console.log('Found unprocessed ad slot:', unprocessedIns)
    //               ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    //               observer.disconnect()
    //             } catch (e) {
    //               console.warn('Adsense push error:', e)
    //             }
    //           }
    //         })

    //         observer.observe(document.body, {
    //           childList: true,
    //           subtree: true
    //         })
    //       }
    //     }
    //   } catch (error) {
    //     console.debug('*** Google Adsense - ERROR LOADING', error)
    //   }
    // }
  }, [shouldBeAds, isAdsTest])

  return null
}

export default GoogleAdsWrapper
